module.exports = "<svg width=\"10\" height=\"7\" viewBox=\"0 0 10 7\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 1.615L1.5 0 5 3.77 8.5 0 10 1.615 5 7\" fill-rule=\"evenodd\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Icon/svg/small_caret_down.svg
// module id = 826
// module chunks = 0